import { createHttpClient } from '@wix/http-client';

export const httpClient = createHttpClient();
